import { Form } from 'semantic-ui-react';
import { Formik, FormikProps } from 'formik';
import './ChangePasswordForm.less';

export interface ChangePasswordFormFields {
	password: string;
	confirmPassword: string;
	code: string;
}

export interface ChangePasswordFormProps {
	noCode?: boolean;
	onSubmit: (values: ChangePasswordFormFields, actions: any) => void;
	renderActionButtons?: (isSubmitting: boolean) => React.ReactNode;
}

export const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({
	onSubmit,
	renderActionButtons,
	children,
	noCode,
}) => {
	return (
		<Formik
			onSubmit={onSubmit}
			initialValues={{
				password: '',
				confirmPassword: '',
				code: '',
			}}
			validate={(values: ChangePasswordFormFields) => {
				const errors: Partial<ChangePasswordFormFields> = {};

				if (
					!/^.*(?=.{8,})(?=.*[a-zA-Z])(?=.*\d)(?=.*[@!#$%&? "]).*$/.test(
						values.password
					)
				) {
					errors.password = `Passwords must be at least 8 characters long, 
					should contain at least 1 number and should contain at least 1 special symbol.`;
				}

				if (values.password !== values.confirmPassword) {
					errors.confirmPassword = `Passwords did not match`;
				}

				if (!noCode) {
					if (!values.code) {
						errors.code = 'Verification code is required.';
					} else if (values.code.length !== 7) {
						errors.code =
							'Verification code should be exactly 7 characters in length.';
					}
				}

				return errors;
			}}
		>
			{({
				values,
				errors,
				touched,
				handleChange,
				handleBlur,
				handleSubmit,
				isSubmitting,
			}: FormikProps<ChangePasswordFormFields>) => (
				<Form className='choose-password-form' onSubmit={handleSubmit}>
					{children}
					<div className='form-fields'>
						<Form.Input
							autoFocus
							fluid
							type='password'
							name='password'
							label='Password'
							placeholder='Password'
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.password}
							error={!!(touched.password && errors.password)}
							required
						/>
						<Form.Input
							fluid
							type='password'
							name='confirmPassword'
							label='Confirm Password'
							placeholder='Confirm Password'
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.confirmPassword}
							error={!!(touched.confirmPassword && errors.confirmPassword)}
							required
						/>
						{!noCode && (
							<Form.Input
								fluid
								type='text'
								name='code'
								label='Verification Code'
								placeholder='ABCD123'
								onChange={handleChange}
								onBlur={handleBlur}
								value={values.code}
								error={!!(touched.code && errors.code)}
								required
							/>
						)}
						<small>
							Password must be at least 8 characters long, should contain at
							least 1 number and should contain at least 1 special symbol.
						</small>
					</div>
					{renderActionButtons && renderActionButtons(isSubmitting)}
				</Form>
			)}
		</Formik>
	);
};
